import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { getFromLocalStorage, setToLocalStorage } from 'src/app/shared/helpers';

@Component({
  selector: 'app-contact-info-edit',
  templateUrl: './contact-info-edit.component.html',
  styleUrls: ['./contact-info-edit.component.scss']
})
export class ContactInfoEditComponent implements OnInit {
  formAlias: string;
  editModeMap = {};
  form: FormGroup;
  submitted = false;
  constructor(protected fb: FormBuilder) { }

  ngOnInit(): void {
    this.formAlias = 'ContactInfo';
    this.form = this.fb.group({
      email: ['', [Validators.email, Validators.required]],
      phone: ['', [Validators.required, Validators.pattern('[0-9]+'), Validators.minLength(9), Validators.maxLength(9)]],
    });
    this.form.patchValue(this.formData);
  }

  onEdit(index: number) {
    this.editModeMap[index] = true;
  }

  done(index: number) {
    if (this.form.valid) {
      this.editModeMap[index] = false;
      setToLocalStorage('policy', this.formAlias, this.form.value);
    } else {
      this.submitted = true;
    }
  }

  get policy(): any {
    return JSON.parse(localStorage.getItem('policy'));
  }

  get formData() {
    const formValue = getFromLocalStorage('policy');
    return formValue && formValue[this.formAlias] ? formValue[this.formAlias] : {} && new Date(parseInt(localStorage.getItem('policy')));
  }

  // numberonly input
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

}
